import React from "react";
import LogoDisplay from "../../Display/Menu/LogoDisplay";

const LogoContainer = () => {
  return <LogoDisplay />;
};

export default LogoContainer;
